import { FilterBase } from "../filterBase"
import { DATA_TYPES } from "../filterConstants"

export class StringFilter extends FilterBase {
  constructor(filterName, filterType, dataScopes, information, visibility, restrictedToScope) {
    super(
      filterName,
      filterType,
      DATA_TYPES.STRING,
      dataScopes,
      information,
      visibility,
      restrictedToScope,
    )
  }

  formatCompareData(a, b) {
    return [a?.toLowerCase(), b?.toLowerCase()]
  }

  isValueValid(_value) {
    return true
  }

  additionalFilters(data) {
    return data.filter(
      (row) =>
        row[this.filterType] &&
        row[this.filterType].toLowerCase().includes(this.value.toLowerCase()),
    )
  }
}
